const Services = {
    "generic": ["E-Commerce", "Web development", "Apps", "Growth Marketing", "Ui / Ux Design", "ADA Compliance"],
    "e-commerce":["Magento", "Shopify+", "Shopify", "Big Commerce", "Demandware", "WooCommerce", "Prestashop", "Custom"],
    "ada-compliance": ["Accessibility Testing", "Accessibility Consulting", "Accessibility Remediation", "Accessibility Training", "PDF Accessibility", "VPAT Creation"],
    "web-development": ["Custom Web App", "Custom Plugin / Integration (Workflow Automation)", "Bots/AI", "CRM", "ERP", "HIPAA Compliant Application"],
    "apps": ["Native Mobile Apps - Mobile/Tablet", "Smart Device Application", "React Native Apps", "Hybrid Apps", "HIPAA Compliant Application"],
    "growth-marketing": ["SEO", "Social Media Management", "Social Media Management", "Content Creation"],
    "ui-ux-design" : ["Wireframing", "Branding", "Motion Design", "User Experience"]
};

export default Services;